import $ from 'jquery';

/**
 * Validate that each delegate email is different.
 * (And also different from the booker).
 */
class UnmatchCheck {
    constructor () {
        this.$submit       = $('.js-next-button');
        this.$mustNotMatch = $('.js-unmatch-check');

        // Button Events
        this.$submit.on('click', $.proxy(this.submitClick, this));
    }

    submitClick () {
        const duplicateValues = this.getDuplicateValues();
        let errorFound        = false;
        let i;

        for (i = 0; i < this.$mustNotMatch.length; i += 1) {
            const $field = $(this.$mustNotMatch[i]);
            const value  = $field.find('input').val();

            if (!$field.is(':visible') || value === '') {
                continue;
            }

            if (duplicateValues.indexOf(value) > -1) {
                errorFound = true;

                const $error = $('<p class="u-warning js-unmatch-error">Please enter a unique email address for each delegate.</p>');

                if (!$field.hasClass('.has-duplicate-warning').length) {
                    $field.append($error);
                    $field.addClass('has-duplicate-warning');
                }
            } else {
                $field.removeClass('has-duplicate-warning');
                $field.find('.js-unmatch-error').remove();
            }
        }

        if (errorFound) {
            alert('You must enter unique email addresses for each delegate.');

            return false;
        }

        // Have all checks passed?
        return true;
    }

    getDuplicateValues () {
        const foundValues = [];
        let i;

        for (i = 0; i < this.$mustNotMatch.length; i += 1) {
            const $field = $(this.$mustNotMatch[i]);
            const value  = $field.find('input').val();

            if (!$field.is(':visible') || value === '') {
                continue;
            }

            foundValues.push(value);
        }

        return UnmatchCheck.findDuplicates(foundValues);
    }

    static findDuplicates (array) {
        const sortedArray = array.slice().sort(); // You can define the comparing function here.
        // JS by default uses a crappy string compare.
        // (we use slice to clone the array so the
        // original array won't be modified)
        const results = [];

        for (let i = 0; i < sortedArray.length - 1; i++) {
            if (sortedArray[i + 1] === sortedArray[i]) {
                results.push(sortedArray[i]);
            }
        }

        return results;
    }
}

export default UnmatchCheck;
